import { Badge, BadgeColor } from "@prequel/shared-components";

import type { ActivityStatus } from "@/api/import/activity";

export const ImportJobStatusLabel: Record<ActivityStatus, string> = {
  queued: "Queued",
  in_progress: "In progress",
  error: "Error",
  completed_with_errors: "Completed with errors",
  success: "Success",
};

export const ImportJobStatusColor: Record<ActivityStatus, BadgeColor> = {
  queued: BadgeColor.GRAY,
  in_progress: BadgeColor.BLUE,
  error: BadgeColor.RED,
  completed_with_errors: BadgeColor.ORANGE,
  success: BadgeColor.GREEN,
};

export const IMPORT_JOB_STATUS_OPTIONS = (Object.keys(ImportJobStatusLabel) as ActivityStatus[]).map((status) => ({
  value: status,
  label: ImportJobStatusLabel[status],
}));

type ImportJobStatusBadgeProps = {
  status: ActivityStatus;
};

const ImportJobStatusBadge = ({ status }: ImportJobStatusBadgeProps) => (
  <Badge className="normal-case" color={ImportJobStatusColor[status]} text={ImportJobStatusLabel[status]} />
);

export default ImportJobStatusBadge;
